import { gql } from "@apollo/client";

export const MUTATION_INSERT_USER_VITAL_SIGN_HISTORY = gql`
  mutation MUTATION_INSERT_USER_VITAL_SIGN_HISTORY($userVitalSignHistory: [userVitalSignHistory_insert_input!]!) {
    insert_userVitalSignHistory(objects: $userVitalSignHistory) {
      returning {
        comment
        created_at
        id
        isTaken
        measure1
        measure2
        unit
        userId
        vitalSign
      }
    }
  }
`;

export const MUTATION_UPDATE_VITAL_SIGN_HISTORY_FROM_DEVICES_BY_USER = gql`
  mutation MUTATION_UPDATE_VITAL_SIGN_HISTORY_FROM_DEVICES_BY_USER($userId: uuid!) {
    insertVitalSignsOfDevice(input: {userId: $userId}) {
      data
      message
      recordsInsertedQuantity
    }
  }
`;